import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  next() {
    this.#navigate("next")
  }

  back() {
    this.#navigate("back")
  }

  #navigate(direction) {
    const field = this.element.querySelector("[data-direction-field]")
    if (field) {
      field.value = direction
      this.element.requestSubmit()
      field.value = ""
    }
  }
}
